module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3jKiZc/tc-custom/9781473845497.jpg?1721404571062",
      "alt": "This image is the cover for the book British Army Guide, 2016–2017"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("British Army Guide, 2016–2017\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In 1984 the first edition of the British Army Guide was published and in September 2015 the 13th edition will be on sale. This invaluable information resource which deals with all aspects of British Army organisation, recruitment and training has been extremely popular with service personnel, the defence industry, military libraries and other groups who are interested in the British Army worldwide. Copies can be seen on desks throughout the UK Ministry of Defence and it would be fair to say that almost every foreign defence attache in London has a copy in his briefcase.Chapters include a Defence Overview; Army Organisation; International Commitments; Armour, Infantry, Artillery, Army Aviation, Engineers, Communications and Combat Service Support; Units of the Army; Recruiting and Training; Reserve Forces plus a final Miscellaneous Chapter which deals with a number of items essential to understanding How the British Army functions on a daily basis. Lavishly illustrated throughout there is no comparable publication available on the market.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charles Heyman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Charles Heyman is an expert in current military personnel and vehicles – air, land and sea.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0